<template functional>
    <div 
        :id="'spl-dashboard-stat-' + props.label"
        class="d-flex justify-content-between align-items-center bg-gray-50 border shadow-sm rounded p-3 spl-dashboard-stat"
        :class="data.staticClass || ''"  
    >  <!-- data.staticClass will pull in classes assigned by parent - but must have ||  -->
        <div class="d-flex align-items-center">
            <b-icon 
                v-if="props.icon"
                :icon="props.icon" 
                font-scale="2.5" 
                :variant="props.variant"
                class="mr-3"
            ></b-icon>
            <div>
                <h5 class="text-muted mb-0">{{ props.label }}</h5>
                <a v-if="props.url" :href="props.url" class="small text-uppercase">{{ props.urlText }}</a>
            </div>
        </div>
        <div>
            <span class="font-size-250 text-muted line-height-100">{{ props.stat }}</span>
        </div>
    </div>
</template>

<script>

export default {
    functional: true,
    name: 'DashboardStat',
    props: {
        label: {
            type: String,
            required: true,
        },
        url: { 
            type: String,
            required: false,
        },
        urlText: {
            type: String,
            default: "View All",
        },
        icon: {
            type: String,
            required: false,
        },
        variant: {  // variant applied to the icon, or other accent color thing you decide later
            type: String,
            default: 'primary',
        },
        stat: {
            type: [String, Number],
            required: false,
        },
    },
}
</script>

<style>

.spl-dashboard-stat {
    border-top: 4px solid var(--secondary-300) !important;
}

</style>